import { Input } from "antd";
import { useState } from "react";

export default function FloatInput(props) {
	const {
		id = "",
		label,
		placeholder,
		value,
		className,
		required,
		size = "large",
		autoComplete = "off",
		...rest
	} = props;

	const [focus, setFocus] = useState(false);

	const new_placeholder = placeholder ?? label;

	const isOccupied = focus || (value && value !== "" && value.length !== 0);

	const labelClass =
		isOccupied || (value && value === "0" && value.length !== 0)
			? "label float-label"
			: "label";

	const requiredMark = required ? (
		<span className="danger-color">*</span>
	) : null;

	return (
		<div
			id={id}
			className={`float-wrapper ${className ? className : ""}`}
			onBlur={() => setFocus(false)}
			onFocus={() => setFocus(true)}
		>
			<Input
				id={id + "_input"}
				value={value}
				size={size}
				autoComplete={autoComplete}
				{...rest}
			/>
			<label className={labelClass} htmlFor={id + "_input"}>
				{isOccupied ? label : new_placeholder} {requiredMark}
			</label>
		</div>
	);
}
